import React, { useRef, useState } from "react";
import { useModalA11y } from "../hooks/useModalA11y";

export default function PinPad({ isOpen, correctPin, onConfirm, onClose, title }) {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");
  const modalRef = useRef(null);
  const cancelRef = useRef(null);

  useModalA11y({
    isOpen,
    onClose: onClose || (() => {}),
    containerRef: modalRef,
    initialFocusRef: cancelRef
  });

  if (!isOpen) return null;

  const handleNumber = (num) => {
    if (input.length < 4) setInput(prev => prev + num);
  };

  const handleSubmit = () => {
    if (input === correctPin) {
      onConfirm();
      setInput("");
      setError("");
    } else {
      setError("Wrong PIN");
      setInput("");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="glass pin-pad-content" ref={modalRef} role="dialog" aria-modal="true" aria-label="PIN entry">
        <h3>{title || "Enter PIN"}</h3>
        <div className="pin-display">{input.padEnd(4, "•")}</div>
        {error && <div className="pin-error" role="alert">{error}</div>}
        <div className="pin-grid">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, "C", 0, "OK"].map((val) => (
            <button 
              key={val} 
              className="btn-nav"
              onClick={() => {
                if (val === "C") setInput("");
                else if (val === "OK") handleSubmit();
                else handleNumber(val);
              }}
            >
              {val}
            </button>
          ))}
        </div>
        {onClose && (
          <button
            className="btn-nav"
            style={{ marginTop: "10px", width: "100%" }}
            onClick={() => {
              setInput("");
              onClose();
            }}
            ref={cancelRef}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
